import type { ComponentType } from 'react'
import React from 'react'
import { getDataAttributes } from '@wix/thunderbolt-commons'

// TODO add data-collapsed with isCollapsed prop if needed for livePreview.
// TODO consider removing ghost comps from structure instead of rendering those divs.
// https://wix.slack.com/archives/C03JEFVDSJW/p1662294281800899?thread_ts=1662291941.507499&cid=C03JEFVDSJW

type Props = {
	id: string
	className: string
}
const GhostComp: ComponentType<Props> = (props) => {
	const { id, className } = props

	return (
		<div
			id={id}
			className={className}
			{...getDataAttributes(props)}
			style={{
				visibility: 'hidden',
				overflow: 'hidden',
				width: 0,
				minWidth: 0,
				height: 0,
				minHeight: 0,
				pointerEvents: 'none',
				margin: 0,
				position: 'absolute',
			}}
		/>
	)
}

export default GhostComp
